import BorrowingConstants from '../constants/BorrowingConstants';
import { getBorrowingSummaries } from '../api/BorrowingApi';

export function fetchSummaries({ accountId }) {
  return {
    types: [BorrowingConstants.FETCH_SUMMARIES_REQUEST, BorrowingConstants.FETCH_SUMMARIES_SUCCESS, BorrowingConstants.FETCH_SUMMARIES_FAILURE],
    middlewareData: {
      accountRequired: true
    },
    apiRequest: (state, apiClient) => getBorrowingSummaries(apiClient, { accountId })
  };
}

export default {
  fetchSummaries
};



// WEBPACK FOOTER //
// ./app/actions/BorrowingActions.js